module.exports = __webpack_public_path__ + "static/img/lifestyle_22.86fdba9a.jpg";